export const SIDEBAR_NAMES = {
    APP_SIDEBAR: 'app-sidebar',
    // DEV_SIDEBAR: 'dev-sidebar',
    HELP_SIDEBAR: 'help-sidebar',
    QUESTION_SIDEBAR: 'question-sidebar',
} as const